/**
 * Sube un PDF de factura a Storage y devuelve URL pública para compartir por WhatsApp/SMS.
 * Mismo bucket que comprobantes (`empresa-assets`), ruta por empresa y factura.
 */
import { supabase } from '../lib/supabase';

const BUCKET = 'empresa-assets';

export async function uploadFacturaPdfPublicLink(
  blob: Blob,
  empresaId: string,
  facturaId: string,
  safeBaseName: string,
): Promise<string | null> {
  if (!empresaId?.trim() || !facturaId?.trim()) return null;
  const clean = String(safeBaseName || 'factura')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .slice(0, 80);
  // Misma convención que comprobantes de pago (RLS `empresa_assets_authenticated_insert`).
  const path = `facturas/${empresaId}/comprobantes/${facturaId}/factura-pdf-${Date.now()}_${clean}.pdf`;

  const { data, error } = await supabase.storage.from(BUCKET).upload(path, blob, {
    contentType: 'application/pdf',
    cacheControl: '120',
    upsert: false,
  });

  if (error) {
    const bytes = typeof blob.size === 'number' ? blob.size : 0;
    const hint =
      /size|maximum|too large/i.test(error.message || '')
        ? ` (PDF ~${Math.round(bytes / 1024 / 1024)} MB; sube el límite del bucket o aplica migración 20260418210000_increase_empresa_assets_file_limit.sql)`
        : '';
    console.warn('[uploadFacturaPdfPublicLink]', error.message + hint);
    return null;
  }

  const { data: pub } = supabase.storage.from(BUCKET).getPublicUrl(data.path);
  return pub?.publicUrl ?? null;
}
